// i18next-extract-mark-ns-start LaRubrique
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Link } from '../../services/link';
import { tabletThresholdPixels, colors } from '../home/v4/styledComponents';
import CTALink from '../CTALink';

export const getUnformattedText = (text : string) => (
  text.replace(/<yellow>/gi, '').replace(/<bold>/gi, '').replace(/\n/gi, ' ').replace(/ {2}/gi, ' ')
    .replace(/<link>/gi, '')
);

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${colors.black};
`;
const CardContainer = styled.div`
    display: flex;
    width: 300px;
    flex-direction: column;
    gap: 10px;
    margin-right: 20px;
    @media (max-width: ${tabletThresholdPixels}) {
        width: 100%;
    }
    `;

const ImgContainer = styled.div`
    width: 100%;
    height: 418px;
    @media (max-width: ${tabletThresholdPixels}) {
        height: 300px;
    }
`;

const Img = styled.img`
  object-fit: cover;
  border-radius: 4px;
  height: 100%;
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 10px;
`;

const SubTitle2 = styled.p`
  font-size: 20px;
  font-family: 'Space Mono', monospace;
  margin: 0;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 15px;
  }
`;

type TextProps = {
    grey?: boolean;
};
const Text = styled.span<TextProps>`
  width: 100%;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 15px;
  ${(props) => props.grey && `color: ${colors.grey600}`};
  @media (max-width: ${tabletThresholdPixels}) {
    margin-bottom: 10px;
  }
`;

type ParagraphProps = {
    lightBlack?: boolean;
    grey?: boolean;
};

const Paragraph = styled.p<ParagraphProps>`
  font-size: 12px;
  ${(props) => props.lightBlack && `color: ${colors.grey800}`};
  ${(props) => props.grey && `color: ${colors.grey600}`};
  max-width: 260px;
  margin: 0;
  @media (max-width: ${tabletThresholdPixels}) {
  }
`;

const ServicesLink = styled.div`
  font-size: 12px;
  color: ${colors.black};
  text-decoration: none;
  display: flex;
  flex-direction: column;
`;

type BlogPostCardProps = {
    data: {
    id: string,
    image: string,
    imageAlt: string,
    title: string,
    text: string,
    service: string,
    example: string,
    delay: string,
    preFilledSteps: {
        selectedCategory: string
    },
    path: string
}};

function BlogPostCard({ data }: BlogPostCardProps) {
  const { t } = useTranslation();
  return (
    <StyledLink to={data.path ? data.path : ''}>
      <CardContainer key={data.id}>
        <ImgContainer>
          <Img src={data.image} alt={t(data.imageAlt)} />
        </ImgContainer>
        <TextContainer>
          <SubTitle2>{data.title ? getUnformattedText(t(data.title)) : null}</SubTitle2>
          <Text grey>{data.text ? getUnformattedText(t(data.text)) : null}</Text>
          {data.service && <Paragraph lightBlack>{t(data.service)}</Paragraph>}
          {data.example && <Paragraph>{t(data.example)}</Paragraph>}
          {data.delay && <Paragraph>{t(data.delay)}</Paragraph>}
          <CTALink fromInteraction="Dressing" linkState={data.preFilledSteps}>
            <ServicesLink>
              {t('En savoir plus')}
            </ServicesLink>
          </CTALink>
        </TextContainer>
      </CardContainer>
    </StyledLink>
  );
}

export default BlogPostCard;
